import * as Yup from 'yup';

const editCommentValidationSchema = Yup.object().shape({
  content: Yup.string().required('Please enter your comment')
});

export default editCommentValidationSchema;
